import { createAction } from "redux-actions";

import {
  GET_WATCH_LIST_ENTRIES,
  GET_WATCH_LIST_ENTRY,
  SET_WATCH_LIST_ENTRIES_SEARCH_FILTERS,
  GET_WATCH_LIST_ENTRIES_COUNT,
  SET_NO_ENTRIES_MESSAGE_WATCHLIST_ENTRIES,
  GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES,
  SET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_FILTERS,
  SET_NO_ENTRIES_MESSAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES,
} from "../types";
import createAsyncActions from "../../../utilities/createAsyncActions";

export const {
  getWatchListEntries,
  getWatchListEntriesPending,
  getWatchListEntriesFulfilled,
  getWatchListEntriesRejected,
} = createAsyncActions(GET_WATCH_LIST_ENTRIES, "getWatchListEntries");

export const {
  getWatchListMultipleSearchEntries,
  getWatchListMultipleSearchEntriesPending,
  getWatchListMultipleSearchEntriesFulfilled,
  getWatchListMultipleSearchEntriesRejected,
} = createAsyncActions(
  GET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES,
  "getWatchListMultipleSearchEntries"
);

export const {
  getWatchListEntriesCount,
  getWatchListEntriesCountPending,
  getWatchListEntriesCountFulfilled,
  getWatchListEntriesCountRejected,
} = createAsyncActions(
  GET_WATCH_LIST_ENTRIES_COUNT,
  "getWatchListEntriesCount"
);

export const {
  getWatchListEntry,
  getWatchListEntryPending,
  getWatchListEntryFulfilled,
  getWatchListEntryRejected,
} = createAsyncActions(GET_WATCH_LIST_ENTRY, "getWatchListEntry");

export const setWatchListEntriesSearchFilters = createAction(
  SET_WATCH_LIST_ENTRIES_SEARCH_FILTERS
);

export const setWatchListEntriesMultipleSearchFilters = createAction(
  SET_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES_FILTERS
);

export const setNoEntriesMessage = createAction(
  SET_NO_ENTRIES_MESSAGE_WATCHLIST_ENTRIES
);

export const setNoEntriesMessageMultipleSearch = createAction(
  SET_NO_ENTRIES_MESSAGE_WATCHLIST_MULTIPLE_SEARCH_ENTRIES
);



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/getWatchListEntriesActions.js